import Button from 'semantic-ui-react/dist/commonjs/elements/Button';
import '@purple/semantic-ui-purple-theme/components/button.css';
import './styles.css';

export default Button;
